import { PartialType, OmitType } from '@nestjs/swagger';
import { CreateAtributoValorDto } from './create-atributo-valor.dto';

export class UpdateAtributoValorDto extends PartialType(
  OmitType(CreateAtributoValorDto, ['atributo_id'] as const),
) {}
